import React from 'react';
import { Link } from 'react-router-dom';

import styles from './styles.module.css';

import Menu from './menu';
import MobileMenu from './mobile-menu';

import colorLogo from '../../../assets/images/logo-solmar.png';

const menus = [
    {
        title: 'Início',
        path: '/',
    },
    {
        title: 'Quem Somos',
        path: '/quem-somos/',
    },
    {
        title: 'Serviços',
        path: '/servicos/',
    },
    {
        title: 'Produtos',
        path: '/produtos/',
    },
    {
        title: 'Contactos',
        path: '/contactos/',
    },
];

const Header = ({ logo = colorLogo, sticky = false, white = false, active = '', mobile = false, history }) => (
    !mobile ?
        <div className={sticky ? styles.sticky : (white ? styles.white : styles.main)}>
            <div className={styles.header}>
                <Link to={{ pathname: '/', state: { fromOtherPages: true } }}>
                    <div className={styles.logo}>
                        <img src={logo} />
                    </div>
                </Link>
                <Menu 
                    active={active} white={white}
                    history={history}
                    menus={menus}/>
            </div>
        </div> :
        <MobileMenu 
            logo={logo}
            active={active}
            history={history}  
            menus={menus}/>
);

export default Header;
